import styled from "styled-components"

export default {
    "Content": styled.div`
        display: flex;
        flex-direction: column;
        gap: 40px;
        padding: 32px 24px 0px 24px;
    `,

    "NoticeDiv": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 24px;

        & > h2 {
            width: 100%;
            ${({ theme }) => theme.font["large-semibold"]};
        }
    `,
    "NoticeList": styled.div`
        display: flex;
        flex-direction: column;
        gap: 12px;
        cursor: pointer;
    `,
    'NoticeElem': styled.div`
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding-bottom: 12px;
        border-bottom: 1px solid ${({ theme }) => theme.color["grey2"]};
        
        & > h2 {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            ${({ theme }) => theme.font["small-medium"]};
        }

        & > p {
            ${({ theme }) => theme.font["tiny-regular"]};
            color: ${({ theme }) => theme.color["grey3"]};
        }
    `,

    "ArticleDiv": styled.div`
        display: flex;
        flex-direction: column;
        gap: 16px;
    `,
    "ArticleTitleDiv": styled.div`
        display: flex;
        justify-content: space-between;
        padding-bottom: 12px;
        border-bottom: ${({ theme, $borderless }) => !$borderless && `1px solid ${theme.color["grey2"]}`};
        
        & > div {
            width: fit-content;
            display: flex;
            align-items: center;
            gap: 8px;

            & > img {
                width: 16px;
            }

            & > h2 {
                ${({ theme }) => theme.font["large-semibold"]};
            }
        }

        & > button {
            width: 20px;
            display: flex;
            justify-content: end;
            align-items: center;
        }
    `,
    "YoutubeList": styled.div`
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
    `,
    "YoutubeElement": styled.div`
        width: calc(50% - 6px);
        display: flex;
        flex-direction: column;
        gap: 8px;
        cursor: pointer;
        
        & > img {
            width: 100%;
            height: 80px;
            object-fit: cover;
            object-position: center center;
            border-radius: 4px;
        }

        & > h2 {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            ${({ theme }) => theme.font["xsmall-regular"]};
        }

        & > p {
            ${({ theme }) => theme.font["tiny-regular"]};
            color: ${({ theme }) => theme.color["grey3"]};
        }
    `,
    "MediaList": styled.div`
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
    `,
    "MediaElement": styled.div`
        display: flex;
        gap: 16px;
        cursor: pointer;

        & > div {
            display: flex;
            flex-direction: column;
            gap: 8px;

            & > h2 {
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                ${({ theme }) => theme.font["small-medium"]};
            }

            & > p {
                ${({ theme }) => theme.font["tiny-regular"]};
                color: ${({ theme }) => theme.color["grey3"]};
            }
        }

        & > img {
            width: 136px;
            min-width: 136px;
            height: 72px;
            object-fit: cover;
            object-position: center center;
            border-radius: 4px;
        }
    `,

    "Option": styled.p`
        ${({ theme }) => theme.font["xsmall-medium"]};
    `,
}


